/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />

module App.Common.Services {
	'use strict';

	export class GuidService {

		public newGuid() {
			var s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
			return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
		}

	}

	angular
		.module('app.common.services')
		.service('app.common.services.guidService', GuidService);
}